export default __webpack_public_path__ + "static/media/project2.6ae56ecc.png";